__webpack_require__.p = "https://uat-sit2a-helix.bac-assets.com//homepage/";